import React, { PureComponent, Fragment } from 'react';
import { Table, Modal, ModalBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { string, number, array } from 'prop-types';
import PostbackLogsItem from './PostbackLogsItem';

class PostbackLogs extends PureComponent {
  static propTypes = {
    logs: array.isRequired,
    error: string,
  };

  static defaultProps = {
    logs: [],
    error: '',
  };

  state = {
    open: false,
    message: '',
  };

  toggleModal = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  showDetailedMessage = message => {
    this.setState(() => ({ open: true, message }));
  };

  clearMessage = () => {
    this.setState(() => ({ message: '' }));
  };

  render() {
    const { logs, error } = this.props;
    const { open, message } = this.state;

    return (
      <Fragment>
        <Table className="postback-logs-table" responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>
                <FormattedMessage id="postback.logs.date" defaultMessage="Date" />
              </th>
              <th>URL</th>
              <th>
                <FormattedMessage id="postback.logs.status" defaultMessage="Status" />
              </th>
              <th>
                <FormattedMessage id="postback.logs.sent" defaultMessage="Sent" />
              </th>
              <th>
                <FormattedMessage id="postback.logs.received" defaultMessage="Received" />
              </th>
              {/* <th>ID</th> */}
            </tr>
          </thead>

          <tbody>
            {logs.length > 0 ? (
              logs.map(log => (
                <PostbackLogsItem key={log.hash} {...log} onShowMore={this.showDetailedMessage} />
              ))
            ) : (
              <tr className="no-data">
                <td colSpan="7">
                  {error ? error : <FormattedMessage id="main.no-data" defaultMessage="No Data" />}
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <Modal
          className="modal-message"
          isOpen={open}
          toggle={this.toggleModal}
          onClosed={this.clearMessage}
          size="lg"
        >
          <ModalBody>
            <pre className="no-margin">{message}</pre>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default PostbackLogs;
